import { Stack } from '@latitude/layout';
import { Status } from '@latitude/status';
import { Text } from '@latitude/text';
import { Tooltip } from '@latitude/tooltip';

import type { FloatingToolbarStatusConfig } from './types';

type StatusItemProps = FloatingToolbarStatusConfig & {
  'data-testid': string;
};

const StatusItem = ({
  status,
  size,
  leadingElement,
  label,
  description,
  descriptionTooltip,
  tooltip,
  className,
  'data-testid': testId,
}: StatusItemProps) => {
  const labelContent = tooltip ? (
    <Tooltip text={tooltip}>
      <span className="truncate">{label}</span>
    </Tooltip>
  ) : (
    <span className="truncate">{label}</span>
  );

  const descriptionContent = descriptionTooltip ? (
    <Tooltip text={descriptionTooltip}>
      <Text variant="captionRegular" color="muted" className="truncate">
        {description}
      </Text>
    </Tooltip>
  ) : (
    <Text variant="captionRegular" color="muted" className="truncate">
      {description}
    </Text>
  );

  const content = (
    <Status
      status={status}
      size={size}
      leadingElement={leadingElement}
      className="max-w-full overflow-hidden"
    >
      {description ? (
        <Stack className="overflow-hidden">
          {labelContent}
          {descriptionContent}
        </Stack>
      ) : (
        labelContent
      )}
    </Status>
  );

  return (
    <div className={className} data-testid={testId}>
      {content}
    </div>
  );
};

export { StatusItem };
